export default {
    teams: sessionStorage.getItem('teams'),
    roles: sessionStorage.getItem('roles'),
}